import { useRef, useState } from "react";
import { decryptData, defaulUrl, formatMoney, Loading, onfocus, printbon } from "../components/const";
import Swal from "sweetalert2";

const ModalAvanceSalaire = ({ travailleur }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState(null);
    const [montant, setMontant] = useState(0)
    const ref = useRef()
    const handleSubmite = async (e) => {
        e.preventDefault();
        if (!montant) {
            setErrors({ 'montant': "Le montant est obligatoire!" });
            return;
        }

        setIsLoading(true)
        const formdata = new FormData(e.target);
        formdata.append('iduser', travailleur?.id);
        formdata.append('montant', montant);
        formdata.append('type', 'dette');

        let status = 0;
        fetch(`${defaulUrl}personnel/avanceSalaire`, {
            method: "POST",
            headers: {
                Accept: 'application/json',
                ContentType: 'application/json',
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
            },
            body: formdata
        }).then((response) => {
            status = response.status;
            return response.json()
        }).then(data => {
            setIsLoading(false);
            if (status == 200) {
                Swal.fire({
                    title: 'Succès',
                    text: `${data.message}\nSouhaitez-vous imprimer le bon?`,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: "OUI",
                    cancelButtonText: "NON"
                }).then((confirm) => {
                    if (confirm.isConfirmed) {
                        printbon(data.id)
                    }
                  
                })
            } else {
                setErrors(data.errors);
            }
        })
        setErrors(null);
    }

    const printbon = (id) => {
        if (!id) {
            return
        }
        let status = 0;
        setIsLoading(true)
        fetch(`${defaulUrl}bon/${id}`, {
            method: "GET",
            headers: {
                Accept: 'application/pdf',
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
            },
            responseType: 'blob'
        }).then((response) => {
            status = response.status;
            return response.blob()
        }).then(data => {
            setIsLoading(false);
            if (status === 200) {
                const url = window.URL.createObjectURL(data)
                const link = document.createElement('a')
                link.href = url
                link.download = `bon_${new Date()}.pdf`
                document.body.appendChild(link)
                link.click()
                window.URL.revokeObjectURL(url)
            }
        })
    }
    return (
        <div className="modal fade " id="modal-avance" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header bg-secondary-subtle">
                        <h1 className="modal-title fs-5" >Avance sur salaire</h1>
                        <button type="button " className="btn-close btn-danger" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <form onSubmit={(e) => handleSubmite(e)} >
                        <div className="modal-body position-relative">
                            <div className="form-group">
                                <label htmlFor="" className="fs-5">Nom complet</label>
                                <input type="text" className="form-control"
                                    value={(`${travailleur?.firstname} ${travailleur?.lastname}`)} disabled />
                            </div>
                            <div className="row py-1">
                                <div className="form-group col-lg-6">
                                    <label htmlFor="salaire" className="fs-5">Salaire</label>
                                    <div className="input-group">
                                        <input type="text" name="salaire" className="form-control" value={(travailleur?.salaire)?.toLocaleString()} disabled />
                                        <span className="input-group-text" id="basic-addon2">GNF</span>
                                    </div>
                                </div>
                                <div className="form-group col-lg-6">
                                    <label htmlFor="" className="fs-5">Dette</label>
                                    <div className="input-group">
                                        <input type="text" className="form-control" name="dette" value={(travailleur?.dette)?.toLocaleString()} disabled />
                                        <span className="input-group-text" id="basic-addon2">GNF</span>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group my-1">
                                <label htmlFor="" className="fs-5">Montant</label>
                                <div className="input-group">
                                    <input type="text" className="form-control" defaultValue={(montant)?.toLocaleString()} onChange={(e) => setMontant(e.target.value.replace(/\D/g, ""))}
                                        onBlur={(e) => formatMoney(e)} onFocus={(e) => onfocus(e)} />
                                    <span className="input-group-text" id="basic-addon2">GNF</span>
                                </div>
                                {errors?.montant && <span className="text-danger">{errors?.montant}</span>}
                            </div>
                            {isLoading && <Loading />}
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal" ref={ref}>Annuler</button>
                                <button type="submite" className="btn btn-success" disabled={isLoading}>Valider</button>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    );
}

export default ModalAvanceSalaire;